import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.4 23.2h19.2q.7-.1.8-.8v-12q-.1-.7-.8-.8h-7.5a4 4 0 0 1-2.4-.8l-1.9-1.4-.5-.2H6.4q-.7.1-.8.8v14.4q.1.7.8.8m19.2 2.4H6.4a3 3 0 0 1-3.2-3.2V8c0-1.8 1.4-3.2 3.2-3.2h7q1 0 1.9.6L17.2 7q.4.3 1 .3h7.4c1.8 0 3.2 1.4 3.2 3.2v12c0 1.8-1.4 3.2-3.2 3.2" })
});
export default SvgFolderRegularIcon;
